import React from "react";

function Orders() {
    return(
        <>
        Orders
        </>
    )
}

export default Orders;